var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "pc_app" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.fullScreen,
              expression: "fullScreen"
            }
          ],
          staticClass: "saas-tree"
        },
        [
          _c(
            "div",
            { staticClass: "left-header" },
            [
              _c(
                "router-link",
                { attrs: { to: _vm.isService ? "/home" : "/thome/5" } },
                [
                  _c("div", {
                    staticClass: "saas-new-icon",
                    style: { backgroundImage: "url(" + _vm.logoUrl + ")" }
                  })
                ]
              ),
              _vm._v(" "),
              !!_vm.isShowUpgrade
                ? _c(
                    "div",
                    {
                      staticClass: "switch-menu",
                      on: { click: _vm.handleChangeMenus }
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isService,
                              expression: "isService"
                            }
                          ]
                        },
                        [_vm._v("服务升级")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isService,
                              expression: "!isService"
                            }
                          ]
                        },
                        [_vm._v("经营转型")]
                      ),
                      _vm._v(" "),
                      _c("i", { staticClass: "el-icon-sort" })
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "saas-menu-search" },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入关键词" },
                  on: { input: _vm.menuSearch },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                },
                [
                  _c(
                    "i",
                    {
                      staticClass: "el-input__icon",
                      attrs: { slot: "prefix" },
                      slot: "prefix"
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          height: "14px",
                          width: "14px",
                          "margin-left": "5px"
                        },
                        attrs: {
                          src:
                            "//img1.jianyewy.com/0eefa0cbb53d159923a1dd49499dbd1c.png"
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "menu-out" },
            [
              _c("ex-menu", {
                attrs: {
                  list: _vm.currentList,
                  menuActive: _vm.menuActive,
                  tabslist: _vm.tabslist
                },
                model: {
                  value: _vm.tabValue,
                  callback: function($$v) {
                    _vm.tabValue = $$v
                  },
                  expression: "tabValue"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.promotion
            ? _c("div", { class: _vm.hotclass }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hot,
                        expression: "hot"
                      }
                    ],
                    staticClass: "is-hot"
                  },
                  [
                    _c("a", { attrs: { href: _vm.promotion.linkName } }, [
                      _c("img", {
                        staticClass: "small",
                        attrs: { src: _vm.promotion.smallImageUrl }
                      })
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "open",
                      attrs: {
                        src:
                          "//img1.jianyewy.com/fee24e939242662b58acd15550ad6281.png"
                      },
                      on: { click: _vm.changeCollapse }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.hot,
                        expression: "!hot"
                      }
                    ],
                    staticClass: "is-hot2"
                  },
                  [
                    _c("a", { attrs: { href: _vm.promotion.linkName } }, [
                      _c("img", { attrs: { src: _vm.promotion.bigImageUrl } })
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-close",
                      on: { click: _vm.closePromotion }
                    })
                  ]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "saas-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.fullScreen,
                expression: "fullScreen"
              }
            ],
            class: ["saas-menu", !_vm.isService ? "bgc2" : "bgc1"]
          },
          [
            _c(
              "div",
              { staticClass: "menu-right fl" },
              [
                _c(
                  "div",
                  {
                    class: { select: _vm.currentIndex == -1 },
                    staticStyle: { "margin-right": "-5px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "header-menu",
                        on: {
                          click: function($event) {
                            _vm.topMenuClickHome(-1)
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "top-icon",
                          staticStyle: {
                            "background-image":
                              "url(//img1.jianyewy.com/e33ca2e172d930234b5868989d07f703.png)"
                          }
                        }),
                        _vm._v("\n            首页")
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.menuLs, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: { select: _vm.currentIndex == index }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "header-menu",
                          on: {
                            click: function($event) {
                              _vm.topMenuClick(item, index)
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "top-icon",
                            style: "background-image: url(" + item.icon + ")"
                          }),
                          _vm._v("\n          " + _vm._s(item.name))
                        ]
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fr" },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      {
                        class: [
                          { "grid-item1": !_vm.isService },
                          "grid-item",
                          { select: _vm.isShowNotice }
                        ]
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-toggle",
                            on: {
                              click: function($event) {
                                _vm.handleShowNotice($event)
                              }
                            }
                          },
                          [
                            _c(
                              "el-badge",
                              {
                                staticClass: "badge-item",
                                attrs: { value: _vm.tipNum, max: 99 }
                              },
                              [
                                _c("img", {
                                  staticClass: "lingdang",
                                  staticStyle: { width: "24px" },
                                  attrs: {
                                    src:
                                      "//img1.jianyewy.com/7fc4271865f581f6fee61c9f7c55a466.png"
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            ref: "dropdownMenu",
                            staticClass: "dropdown-menu",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              },
                              mouseleave: function($event) {
                                _vm.handlehideNotice()
                              }
                            }
                          },
                          [
                            _c("li", { staticClass: "header" }, [
                              _vm._v("您有" + _vm._s(_vm.tipNum) + "个系统通知")
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "div",
                                { staticClass: "content" },
                                _vm._l(_vm.noticeList, function(item, index) {
                                  return _vm.noticeList
                                    ? _c("ul", { key: index }, [
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javaScript:void(0)"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.noticesClick(item)
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(item.notificaTitle))]
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                })
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "footer" }, [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.noticesAll()
                                    }
                                  }
                                },
                                [_vm._v("查看所有信息")]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      {
                        class: [
                          { "grid-item1": !_vm.isService },
                          "grid-item",
                          { "user-header": _vm.isService },
                          { "user-header1": !_vm.isService },
                          { select: _vm.topmenuVis }
                        ]
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-toggle",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.clickShowMenus($event)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "header-icon",
                              staticStyle: { width: "24px" },
                              attrs: {
                                src:
                                  "//img1.jianyewy.com/f7f955f8ce23d2c6d596f92ce1b80c87.png"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { class: { "color-black": !_vm.isService } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.state.user.realName || "用户您好"
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "icon-arrow" }, [
                              _c("img", {
                                staticClass: "arrow",
                                staticStyle: { width: "10px" },
                                attrs: {
                                  src: _vm.topmenuVis
                                    ? "//img1.jianyewy.com/0b6a8a518f8a016879216aac9e38ca1f.png"
                                    : "//img1.jianyewy.com/1aa060eb4d8c8c008961db2204a6b3c3.png"
                                }
                              })
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.topmenuVis,
                        expression: "topmenuVis"
                      }
                    ],
                    staticClass: "dropdown-header",
                    on: {
                      mouseleave: function($event) {
                        _vm.handlehideMenus()
                      }
                    }
                  },
                  [
                    _c(
                      "ul",
                      {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.headerClick()
                          }
                        }
                      },
                      [
                        _vm._l(_vm.headerMenus, function(item, index) {
                          return _vm.headerMenus
                            ? _c("li", { key: index }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javaScript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        _vm.clickTopMenu(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "16px",
                                        height: "16px"
                                      },
                                      attrs: {
                                        src:
                                          item.icon ||
                                          "//img1.jianyewy.com/d64c148a84baf713a5241b52879304be.png"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(item.name))])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "bot-line" })
                              ])
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _c("li", { staticClass: "footer" }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  _vm.loginOut()
                                }
                              }
                            },
                            [_c("span", [_vm._v("退出")])]
                          )
                        ])
                      ],
                      2
                    )
                  ]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "saas-tabs" }, [
          _c(
            "div",
            { staticClass: "tabs-left" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  on: {
                    "tab-remove": _vm.removeTab,
                    "tab-click": _vm.clickTab
                  },
                  model: {
                    value: _vm.tabValue,
                    callback: function($$v) {
                      _vm.tabValue = $$v
                    },
                    expression: "tabValue"
                  }
                },
                [
                  _c("el-tab-pane", {
                    attrs: {
                      label: "首页",
                      name: !_vm.isService ? "shouye1" : "shouye",
                      frontUrl: !_vm.isService ? "/thome/5" : "/"
                    }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.tabslist, function(item, index) {
                    return _c("el-tab-pane", {
                      key: item.name,
                      attrs: {
                        label: item.title,
                        name: item.name,
                        frontUrl: item.url,
                        closable: item.title != "首页"
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tabs-menu" },
            [
              _c(
                "el-menu",
                {
                  staticClass: "el-menu-demo",
                  attrs: { mode: "horizontal", "active-text-color": "#909399" }
                },
                [
                  _c(
                    "el-submenu",
                    { attrs: { index: "1" } },
                    [
                      _c("template", { slot: "title" }, [_vm._v("操作")]),
                      _vm._v(" "),
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "1-1" },
                          on: {
                            click: function($event) {
                              _vm.removeTab(_vm.tabValue)
                            }
                          }
                        },
                        [_vm._v("关闭当前")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "1-2" },
                          on: {
                            click: function($event) {
                              _vm.closeAll()
                            }
                          }
                        },
                        [_vm._v("关闭所有")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "1-4" },
                          on: {
                            click: function($event) {
                              _vm.closeOther()
                            }
                          }
                        },
                        [_vm._v("关闭其他")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "1-3" },
                          on: {
                            click: function($event) {
                              _vm.repush(_vm.tabValue)
                            }
                          }
                        },
                        [_vm._v("刷新当前页面")]
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "saas-view" },
          [
            _vm._l(_vm.skylinelist, function(item) {
              return [
                item.isEx
                  ? _c("iframe-view", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.name == _vm.tabValue,
                          expression: "item.name==tabValue"
                        }
                      ],
                      attrs: { frontUrl: item.url, ifid: item.name }
                    })
                  : _vm._e()
              ]
            }),
            _vm._v(" "),
            _c(
              "keep-alive",
              { attrs: { include: _vm.includeArr } },
              [
                _vm.isRouterAlive
                  ? _c("router-view", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isSkyLine,
                          expression: "!isSkyLine"
                        }
                      ]
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.modal.title,
            visible: _vm.modal.show,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.$set(_vm.modal, "show", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.modal.message))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.modal.buttons && _vm.modal.buttons[0].click()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.modal.buttons && _vm.modal.buttons[0].text))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "通知",
            "custom-class": "noticeDlg",
            visible: _vm.noticeVisible,
            "close-on-click-modal": false,
            "show-close": false,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.noticeVisible = $event
            }
          }
        },
        [
          _c(
            "el-container",
            [
              _c("el-header", { attrs: { height: "auto" } }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.noticeItem.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "des" }, [
                  _vm._v(
                    "发布人：" +
                      _vm._s(_vm.noticeItem.sendOrganName) +
                      "   " +
                      _vm._s(
                        _vm._f("dateFormat")(
                          _vm.noticeItem.sendTime,
                          "yyyy-MM-dd hh:mm:ss"
                        )
                      )
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.noticeVisible
                ? _c("el-main", [
                    _c("div", {
                      staticClass: "content",
                      domProps: { innerHTML: _vm._s(_vm.noticeItem.notice) }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "line" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "footer" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.closeAlert(_vm.noticeItem.id)
                              }
                            }
                          },
                          [_vm._v("我知道了")]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }